import React, { useState } from 'react';

const TextScramble = ({ children, className = '', speed = 50 }) => {
    const [displayText, setDisplayText] = useState(children);
    const [isAnimating, setIsAnimating] = useState(false);

    const scramble = () => {
        if (isAnimating) return;

        setIsAnimating(true);
        const originalText = children;
        const letters = originalText.split('');
        let iterations = 0;
        const maxIterations = originalText.length;

        const interval = setInterval(() => {
            // Shuffle the letters randomly
            const shuffled = [...letters]
                .map((char, index) => {
                    if (char === ' ') return ' '; // Keep spaces in place

                    // If we've reached this position, show the correct letter
                    if (index < iterations) {
                        return originalText[index];
                    }

                    // Otherwise, show a random letter from the original text
                    const availableLetters = letters.filter(c => c !== ' ');
                    return availableLetters[Math.floor(Math.random() * availableLetters.length)];
                })
                .join('');

            setDisplayText(shuffled);

            iterations += 1;

            if (iterations > maxIterations) {
                clearInterval(interval);
                setDisplayText(originalText);
                setIsAnimating(false);
            }
        }, speed);
    };

    return (
        <span
            className={className}
            onMouseEnter={scramble}
            style={{ cursor: 'pointer', display: 'inline-block' }}
        >
            {displayText}
        </span>
    );
};

export default TextScramble;
